import { getCurrentTeam } from './store-service';
import { getTeamPlan, getTeamIsOnTrial } from '../utils/billing';

const FREE_PLANS = ['X_Basic_Plan'];
const EDUCATIONAL_PLANS = ['X_Educational_Annual', 'X_Educational_Monthly'];
const APP_SUMO_PLANS = ['App_Sumo_1', 'App_Sumo_2', 'App_Sumo_3', 'App_Sumo_4', 'App_Sumo_5', 'App_Sumo_6', 'App_Sumo_7', 'App_Sumo_8', 'App_Sumo_9', 'App_Sumo_10', 'App_Sumo_11', 'App_Sumo_12', 'App_Sumo_13', 'App_Sumo_14', 'App_Sumo_15', 'App_Sumo_16', 'App_Sumo_17', 'App_Sumo_18', 'App_Sumo_19', 'App_Sumo_20', 'App_Sumo_21', 'App_Sumo_22', 'App_Sumo_23', 'App_Sumo_24', 'App_Sumo_25'];
const LEVEL_10_FIXED_PLANS = ['X_Starter', 'X_Starter_Monthly', 'X_Starter_Yearly'];
const LEVEL_10_PLANS = [...LEVEL_10_FIXED_PLANS, 'X_Level_10_2021_PS_Monthly', 'X_Level_10_2021_PS_Yearly', 'X_Level_10_2021A_PS_Monthly', 'X_Level_10_2021A_PS_Yearly'];
const LEVEL_20_FIXED_PLANS = ['X_Pro_Yearly', 'X_Pro_Monthly'];
const LEVEL_20_PLANS = [...LEVEL_20_FIXED_PLANS, 'X_Level_20_2021_PS_Yearly', 'X_Level_20_2021_PS_Monthly'];
const LEVEL_30_PLANS = ['X_Business_Yearly', 'X_Business_Monthly', 'X_Level_30_2021_PS_Yearly', 'X_Level_30_2021_PS_Monthly'];
const ENTERPRISE_PLANS = ['X_Enterprise_Yearly', 'X_Enterprise_Monthly'];
const LIFETIME_PLANS = ['X_Lifetime_1', 'X_Lifetime_2', 'X_Lifetime_3', 'X_Lifetime_4', 'X_Lifetime_5', 'X_Lifetime_6', 'X_Lifetime_7', 'X_Lifetime_8', 'X_Lifetime_9'];

export const FEATURES = {
    import: {
        disable: [],
        onTrial: true
    },
    inviteGuests: {
        disable: [...FREE_PLANS],
        onTrial: false
    },
    timeTracking: {
        enable: [...LEVEL_10_PLANS, ...LEVEL_20_PLANS, ...LEVEL_30_PLANS, ...ENTERPRISE_PLANS, ...EDUCATIONAL_PLANS, ...APP_SUMO_PLANS, ...LIFETIME_PLANS],
        onTrial: true,
        // addon: true,
        // price: 20
    },
    teamSSOOnly: {
        enable: [...LEVEL_30_PLANS, ...ENTERPRISE_PLANS, ...EDUCATIONAL_PLANS, ...APP_SUMO_PLANS, ...LIFETIME_PLANS],
        onTrial: true
    },
    microsoftSSO: {
        enable: [...LEVEL_30_PLANS, ...ENTERPRISE_PLANS, ...EDUCATIONAL_PLANS, ...APP_SUMO_PLANS, ...LIFETIME_PLANS],
        onTrial: true
    },
    hideFromGuests: {
        enable: [],
        disable: [...FREE_PLANS, ...LEVEL_10_PLANS],
        onTrial: true
    },
    customFields: {
        enable: [...LEVEL_10_PLANS, ...LEVEL_20_PLANS, ...LEVEL_30_PLANS, ...ENTERPRISE_PLANS, ...EDUCATIONAL_PLANS, ...APP_SUMO_PLANS, ...LIFETIME_PLANS],
        onTrial: true
    },
    workloads: {
        enable: [...LEVEL_30_PLANS, ...ENTERPRISE_PLANS, ...EDUCATIONAL_PLANS, ...APP_SUMO_PLANS, ...LIFETIME_PLANS],
        onTrial: true,
        addon: true,
        fixedPlansOnly: true,
        price: {
            annual: 20,
            monthly: 29
        }
    },
    projectOverview: {
        disable: [...FREE_PLANS, ...LEVEL_10_PLANS],
        onTrial: true,
        addon: true,
        fixedPlansOnly: true,
        price: {
            annual: 20,
            monthly: 29
        }
    },
    subteams: {
        disable: [],
        onTrial: true
    },
    unlimitedMembers: {
        enableTeams: ['livetransferagency']
    },
    automationsVisible: {
        disable: [...LIFETIME_PLANS]
    },
    automations: {
        enable: [...LEVEL_20_PLANS, ...LEVEL_30_PLANS, ...ENTERPRISE_PLANS, ...EDUCATIONAL_PLANS, ...APP_SUMO_PLANS]
    },
    customRoles: {
        enable: [...LEVEL_30_PLANS, ...ENTERPRISE_PLANS, ...EDUCATIONAL_PLANS, ...APP_SUMO_PLANS, ...LIFETIME_PLANS]
    },
    cname: {
        addon: true,
        enable: [...APP_SUMO_PLANS],
        price: {
            annual: 20,
            monthly: 29
        }
    }
};

const featureTypeExists = featureType => {
    if (!(featureType in FEATURES)) {
        console.error(`Features Service: illegal feature type: ${featureType}`);

        return false;
    }

    return true;
}

export const featureAvailable = (featureType, planDefault, team = getCurrentTeam()) => {
    const plan = getTeamPlan(team);
    const onTrial = getTeamIsOnTrial(team);

    if (!featureTypeExists(featureType)) {
        return false;
    }

    if (FEATURES[featureType].enableTeams?.includes(team?.team_url)) {
        return true;
    }

    if (!plan) {
        return false;
    }

    if (team?.features?.includes(featureType) && !planDefault) {
        return true;
    }

    if ('onTrial' in FEATURES[featureType] && onTrial) {
        return true;
    }

    return (FEATURES[featureType].enable && FEATURES[featureType].enable.includes(plan)) || (FEATURES[featureType].disable && !FEATURES[featureType].disable.includes(plan));
}
